module.exports = __webpack_public_path__ + "img/ktb.bccf1cdf.svg";